"use strict";

import Vue from "vue";
import axios from "axios";
import util from "@/util";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: "https://dev-v2.bundleb2b.net/apidoc-server/app/mock/21/",
  baseURL: "https://macausjm.mez100.com.cn/",
  // baseURL: "https://bebackend.macausjm-glp.com",
  // baseURL: "https://beadmin-qa.macausjm-glp.com/",
  // baseURL: "https://beadmin.macausjm-glp.com",
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  transformResponse: [
    function (data) {
      return JSON.parse(data);
    },
  ],
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers.Authorization = util.getCookie("Authorization");
    config.headers.Lang =
      localStorage.getItem("lang") || process.env.VUE_APP_I18N_LOCALE;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.data.code >= 200) {
      if (response.headers.authorization) {
        util.addDefaultCookie("Authorization", response.headers.authorization);
      }
    } else {
      util.removeCookie("Authorization", { path: "/" });
      window.location.href = "/";
    }
    return response.data;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
